<script>
  import router from 'page'

  // Include our Routes
  import Home from './routes/home/MainApp.svelte'
  import Wordgen from './routes/wordgen/WordgenApp.svelte'
  import About from './routes/wordgen/about/About.svelte'


  // Variables
  let page

  // Set up the pages to watch for
  router('/', () => (page = Home))
  router('/wordgen', () => (page = Wordgen))
  router('/wordgen/about', () => (page = About))

  // Set up the router to start and actively watch for changes
  router.start()
</script>

<div class="main-content-background">
  <div class="transparent-gradient">
    <svelte:component this={page} />
  </div>
</div>

<style>
  .main-content-background {
    position: relative;
    top: 0px;
    left: 0px;
    padding: 0px;
    margin: 0px;
    min-height: 100vh;
    height: 100%;
    background-color: #02023062;
    background-image: url(/img/kbd.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    background-blend-mode: color-dodge;
  }

  .transparent-gradient {
    position: sticky;
    top: 0px;
    left: 0px;
    height: 100%;
    background-attachment: fixed;
    min-height: 100vh;
    background-color: black;
    background: radial-gradient(transparent 40%, rgba(0,0,0,1)) ;
  }
</style>